import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import useStyles from './Editor.style';

import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createShortCritic, updateShortCritic } from 'redux/actions/CriticsManager';

let Editor = () => <React.Fragment />;

const ManageShortCritic = ({ shortCritic }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);

  const movieId = params.get('movie');

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  React.useEffect(() => {
    Editor = require('react-draft-wysiwyg').Editor;
    if (shortCritic) {
      setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(shortCritic.critic_article))));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [shortCritic]);

  const handleSubmit = () => {
    const content = convertToRaw(editorState.getCurrentContent());
    const data = {
      id: shortCritic?.id,
      critic_article: JSON.stringify(content),
    };
    if (editorState !== '' && !shortCritic) {
      dispatch(createShortCritic(movieId, data));
    } else {
      dispatch(updateShortCritic(movieId, data));
    }
  };

  return (
    <React.Fragment>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={12} className={classes.editorRoot}>
          <Editor
            editorStyle={{
              width: '100%',
              minHeight: 100,
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: 'lightgray',
            }}
            toolbar={{
              options: [
                'inline',
                'blockType',
                'fontSize',
                'list',
                'textAlign',
                'colorPicker',
                'link',
                'emoji',
                'remove',
                'history',
              ],
            }}
            editorState={editorState}
            onEditorStateChange={editorState => setEditorState(editorState)}
          />
        </Grid>
      </GridContainer>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={() => history.goBack()}>{shortCritic === null ? 'لغو' : 'بازگشت'}</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            ثبت نقد
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default ManageShortCritic;
